// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"5d826acf","260":"769f1c01","270":"ed3592b2","292":"9e2fe9e0","437":"8c93f8a9","628":"8e5498aa"}[chunkId] + ".chunk.js";
};